export default __webpack_public_path__ + "static/media/tdlogo.bd60c7e6.jpeg";